import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { eightyFormAction } from "../../api/services/formService";

export const eightyGAction = createAsyncThunk(
  "formData/eightyGForm",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await eightyFormAction(formData);
      
      // API returns JSON with pdfUrl: { message, status, pdfUrl }
      const responseData = response.data || response;
      const pdfUrl = responseData.pdfUrl || responseData.pdf_url;
      
      if (pdfUrl) {
        // Open PDF URL in new tab instead of downloading
        window.open(pdfUrl, '_blank');
        return { 
          status: true, 
          message: responseData.message || "80G certificate opened in new tab",
          pdfUrl: pdfUrl
        };
      } else {
        // Fallback: if no pdfUrl, check for blob (backward compatibility)
        if (responseData instanceof Blob) {
          const url = window.URL.createObjectURL(new Blob([responseData]));
          window.open(url, '_blank');
          window.URL.revokeObjectURL(url);
          return { status: true, message: "80G certificate opened in new tab" };
        }
        return { status: true, message: responseData.message || "80G certificate generated" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to generate 80G certificate');
    }
  }
);

const eightGSlice = createSlice({
  name: "eightyG",
  initialState: {
    loading: false,
    success: false,
    error: null,
    formData: null
  },
  reducers: {
    resetEightyGState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.formData = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(eightyGAction.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(eightyGAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.formData = action.payload;
      })
      .addCase(eightyGAction.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetEightyGState } = eightGSlice.actions;
export default eightGSlice.reducer;

